import {_hasProperty} from "./HelperFunc";

export default class HelperGoogleAnalytics4 {
	static TrackRegisterEvent(method) {
		if (typeof trackGA4RegisterEvent !== 'function') {
			return;
		}

		// eslint-disable-next-line no-undef
		trackGA4RegisterEvent(method);
	}

	static TrackLoginEvent(method) {
		if (typeof trackGA4LoginEvent !== 'function') {
			return;
		}

		// eslint-disable-next-line no-undef
		trackGA4LoginEvent(method);
	}

	static TrackEcommerceEvent(eventName, eventData) {
		if (typeof trackGA4EcommerceEvent !== 'function') {
			return;
		}

		// eslint-disable-next-line no-undef
		trackGA4EcommerceEvent(eventName, eventData);
	}

	static TrackEvent(category, action, label) {
		if (typeof trackGA4Event !== 'function') {
			return;
		}
		const eventData = {
			category,
			action,
			label
		}

		// eslint-disable-next-line no-undef
		trackGA4Event(eventData);
	}

	static TrackSelectItemEvent(listId, listName, items) {

		if (!Array.isArray(items) || items.length === 0) {
			return;
		}

		const eventData = {
			item_list_id: listId,
			item_list_name: listName,
			items: items
		}

		this.TrackEcommerceEvent('ga4_select_item', eventData);

	}

	static TrackViewCart(value, currency, items) {

		if (!Array.isArray(items) || items.length === 0) {
			return;
		}

		const eventData = {
			currency: currency,
			value: value,
			items: items
		}

		this.TrackEcommerceEvent('ga4_view_cart', eventData);

	}

	static TrackBeginCheckout(value, items) {

		if (!Array.isArray(items) || items.length === 0) {
			return;
		}

		let coupon = '';
		const currency = items[0].currency;


		let hasNewServiceDiscount = false;
		let hasReNewServiceDiscount = false;
		for (var i = 0; i < items.length; i++) {
			const couponInner = items[i].coupon;
			if (couponInner === 'Нова услуга' || couponInner == 'Подновяване') {
				hasNewServiceDiscount = couponInner === 'Нова услуга' ? true : hasNewServiceDiscount;
				hasReNewServiceDiscount = couponInner === 'Подновяване' ? true : hasReNewServiceDiscount;
			} else if (couponInner) {
				coupon = couponInner;
			}
		}

		if (hasNewServiceDiscount && hasReNewServiceDiscount) {
			coupon = 'Нова услуга/Подновяване';
		} else if (hasNewServiceDiscount) {
			coupon = 'Нова услуга';

		} else if (hasReNewServiceDiscount) {
			coupon = 'Подновяване';
		}


		const eventData = {
			currency: currency,
			value: value,
			items: items
		}

		if (coupon !== '') {
			eventData['coupon'] = coupon;
		}

		this.TrackEcommerceEvent('ga4_begin_checkout', eventData);

	}

	static TrackContinueButton(variant) {
		this.TrackEvent('InCart Actions', 'Continue Button clicked', 'Variant/' + variant);

	}

	static GetAnalyticsEventLabelSimple(taxonomy) {
		if (!taxonomy) return '';
		const {category, name} = taxonomy;


		let eventLabel = 'Product Category/' + category;
		eventLabel = eventLabel + ' - Product Name/' + name;
		return eventLabel;
	}

	static GetAnalyticsEventLabel(taxonomy, isNewService) {
		if (!taxonomy) return '';
		const {category, brand, name} = taxonomy;
		const variant = isNewService === true ? 'New' : 'Renew';

		const checkoutStep = sessionStorage.getItem('checkoutStep');


		let eventLabel = 'Product Category/' + category;
		if (checkoutStep) {
			eventLabel = eventLabel + ' - Checkout/Step ' + checkoutStep;
		}
		eventLabel = eventLabel + ' - Product Brand/' + brand;
		eventLabel = eventLabel + ' - Product Name/' + name;
		eventLabel = eventLabel + ' - Product Variant/' + variant;
		return eventLabel;
	}

	static TrackServicePriceSelectorOpen(taxonomy, isNewService) {
		if (!taxonomy) return;
		this.TrackEvent('InCart Actions', 'Periods selector - Open', this.GetAnalyticsEventLabel(taxonomy, isNewService));
	}

	static TrackServicePriceSelectorClose(taxonomy, isNewService, selectedTerm) {
		if (!taxonomy) return;
		let eventLabel = this.GetAnalyticsEventLabel(taxonomy, isNewService);
		eventLabel = eventLabel + ' - Product Term/' + selectedTerm;
		this.TrackEvent('InCart Actions', 'Periods selector - Plan selected', eventLabel);
	}
}
